import { Col, Select } from "antd";
import { ISectorField } from "./ISectorField";

const { Option } = Select;

const SectorField = ({
	value,
	fieldName,
	index,
	translations,
	canonicalValues,
	errors,
	handleSelectOrDatePicker,
	disabled = false,
}: ISectorField) => (
	<Col xs={24} md={12} lg={12} className="titles">
		<label className="required"> {translations.activitySector} </label>
		<Select
			className="input-field"
			value={value ? value.split(';') : []}
			disabled={disabled}
			onChange={(values: string[]) => handleSelectOrDatePicker(fieldName, index || 0)(values.join(';'))}
			status={errors[index].sector ? 'error' : ''}
			placeholder={translations.seleccioneOpcion}
			mode="multiple"
			showSearch
			filterOption={(input, option) =>
				(option!.children as unknown as string).includes(input)
			}
		>
			{translations.sectorOptions.map((option: string, idx: number) => (
				<Option key={idx} value={canonicalValues?.[idx] || option}>{option}</Option>
			))}
			<Option value="Otro">{translations.otherSpecify}</Option>
		</Select>
		<span className={`error ${errors[index].sector ? 'show' : null}`}>{translations.seleccioneOpcion}</span>
	</Col>
);

export default SectorField;
